// Copied verbatim from tab-portal src/lib/name-identification (qa c50f5268), the portal mirror of
// core-api src/utils/nameIdentification. Rules only: no AI pass. Keep the three in step.
import { tokenLooksLikeGiven, tokenLooksLikeSurname } from './parsePersonName'
import { normalizeName, tokenize } from './normalize'
import { NameOrder } from './types'

/**
 * Infer dominant person-name token order for a file column.
 * Comma convention wins; otherwise vote surname-first vs given-first heuristics.
 */
export const inferNameOrder = (names: string[]): NameOrder => {
  const samples = names.map(normalizeName).filter(Boolean)
  if (samples.length === 0) return 'surname-first'

  let commaCount = 0
  let surnameFirstVotes = 0
  let givenFirstVotes = 0

  for (const name of samples) {
    if (name.includes(',')) {
      commaCount += 1
      continue
    }

    const tokens = tokenize(name)
    if (tokens.length < 2) continue

    const first = tokens[0]
    const second = tokens[1]

    if (tokenLooksLikeSurname(first) && tokenLooksLikeGiven(second)) {
      surnameFirstVotes += 1
    } else if (tokenLooksLikeGiven(first) && tokenLooksLikeSurname(second)) {
      givenFirstVotes += 1
    }
  }

  if (commaCount > samples.length / 4) return 'surname-first'
  if (givenFirstVotes > surnameFirstVotes * 1.5) return 'given-first'
  return 'surname-first'
}
